import { createContext, useContext } from "react"
import { useMotionValue } from "framer-motion"

const Context = createContext()

export const RollerProvider = ({ children }) => {
  const currentIndex = useMotionValue(0)
  return <Context.Provider value={{ currentIndex }}>{children}</Context.Provider>
}

export const useRoller = () => useContext(Context)
